<xemex-dialog-shell [title]="'devices.detailTabs.readout.label' | translate">
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <xemex-detail-field
      [label]="'devices.detailTabs.readout.initiatedBy' | translate"
      [loading]="deviceStore.isLoadingReadoutStatus() && !readoutStatus()"
    >
      {{ readoutStatus()?.initiatedBy }}
    </xemex-detail-field>

    <xemex-detail-field
      [label]="'devices.detailTabs.readout.initiatedOn' | translate"
      [loading]="deviceStore.isLoadingReadoutStatus() && !readoutStatus()"
    >
      {{ $safeNavigationMigration(readoutStatus()?.initiatedOn) | date: 'HH:mm:ss dd MMM yyyy' }}
    </xemex-detail-field>

    <xemex-detail-field
      [label]="'devices.detailTabs.readout.status' | translate"
      [loading]="deviceStore.isLoadingReadoutStatus() && !readoutStatus()"
    >
      @if (readoutStatus()?.status; as status) {
        <xemex-status-chip [status]="statusType(status)" [label]="status" />
      }
    </xemex-detail-field>

    @if (data.error || readoutStatus()?.error) {
      <xemex-detail-field [label]="'devices.detailTabs.readout.error' | translate">
        {{ data.error || readoutStatus()?.error }}
      </xemex-detail-field>
    }
  </div>

  @if (readoutStatus()?.status === 'Success') {
    <p class="mt-4 text-sm text-neutral">
      {{ 'devices.detailTabs.readout.successText' | translate }}
    </p>
  }

  <div actions>
    <xemex-filled-button type="button" (click)="dialogRef.close()">
      {{ 'general.btnClose' | translate }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
